const DeviceCondition = {
    NEW: "NEW",
    IN_USE: "IN_USE",
    BROKEN: "BROKEN"
}

export default DeviceCondition;